import { render, staticRenderFns } from "./u-main-section-aside.vue?vue&type=template&id=3cceec64"
import script from "./u-main-section-aside.vue?vue&type=script&lang=js"
export * from "./u-main-section-aside.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports